const BASE_URL = process.env.REACT_APP_API_URL || "";

function getToken() { return localStorage.getItem("ar_token"); }
function getAdminToken() { return localStorage.getItem("ar_admin_token"); }

async function request(path, options = {}, useAdmin = false) {
  const token = useAdmin ? getAdminToken() : getToken();
  const headers = { "Content-Type": "application/json", ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || "Request failed");
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  // Customer auth
  login:          (body) => request("/auth/login",           { method: "POST", body: JSON.stringify(body) }),
  register:       (body) => request("/auth/register",        { method: "POST", body: JSON.stringify(body) }),
  forgotPassword: (body) => request("/auth/forgot-password", { method: "POST", body: JSON.stringify(body) }),
  resetPassword:  (body) => request("/auth/reset-password",  { method: "POST", body: JSON.stringify(body) }),
  verifyEmail:    (token) => request("/auth/verify?token=" + token),
  verifyInvite:   (token) => request("/auth/verify-invite?token=" + token),

  // Customer portal
  getDashboard:           ()         => request("/api/dashboard"),
  getInvoices:            (p)        => request("/api/invoices?" + (p || "")),
  getJobs:                ()         => request("/api/jobs"),
  getInvoice:             (id)       => request("/api/invoices/" + id),
  getInvoiceDownload:     (id)       => request("/api/invoices/" + id + "/download"),
  getPayments:            (p)        => request("/api/payments?" + (p || "")),
  getAccount:             ()         => request("/api/account"),
  getInvoiceStatus:       (id)       => request("/api/invoices/" + id + "/status"),
  submitDispute:          (id, body) => request("/api/invoices/" + id + "/dispute", { method: "POST", body: JSON.stringify(body) }),
  requestTickets:         (id)       => request("/api/invoices/" + id + "/request-tickets", { method: "POST", body: JSON.stringify({}) }),
  requestOfficialInvoice: (id)       => request("/api/invoices/" + id + "/request-official", { method: "POST" }),

  // Notifications
  getNotifications:        ()  => request("/api/notifications"),
  dismissNotification:     (id) => request("/api/notifications/" + id + "/dismiss", { method: "POST" }),
  dismissAllNotifications: ()  => request("/api/notifications/dismiss-all", { method: "POST" }),

  // Admin auth
  adminLogin:               (body)     => request("/admin/auth/login",           { method: "POST", body: JSON.stringify(body) }),
  adminChangePassword:      (body)     => request("/admin/auth/change-password", { method: "POST", body: JSON.stringify(body) }, true),
  adminResetPasswordViaToken: (body)   => request("/admin/auth/reset-password",  { method: "POST", body: JSON.stringify(body) }),

  // Admin portal
  adminDashboard:           ()         => request("/admin/dashboard", {}, true),
  adminGetCustomers:        (p)        => request("/admin/customers?" + (p || ""), {}, true),
  adminGetCustomer:         (id)       => request("/admin/customers/" + id, {}, true),
  adminResetPassword:       (id, body) => request("/admin/customers/" + id + "/reset-password", { method: "POST", body: JSON.stringify(body) }, true),
  adminToggleActive:        (id)       => request("/admin/customers/" + id + "/toggle-active", { method: "POST", body: JSON.stringify({}) }, true),
  adminImpersonate:         (id)       => request("/admin/impersonate/" + id, {}, true),
  adminPreview:             (id)       => request("/admin/preview/" + id, {}, true),
  adminGetDisputes:         (status)   => request("/admin/disputes?status=" + (status || "pending"), {}, true),
  adminUpdateDispute:       (id, body) => request("/admin/disputes/" + id, { method: "PATCH", body: JSON.stringify(body) }, true),
  adminGetTicketRequests:   (status)   => request("/admin/ticket-requests?status=" + (status || "pending"), {}, true),
  adminFulfillTicket:       (id)       => request("/admin/ticket-requests/" + id + "/fulfill", { method: "POST", body: JSON.stringify({}) }, true),
  adminUploadTicket:        (id, body) => request("/admin/ticket-requests/" + id + "/upload", { method: "POST", body: JSON.stringify(body) }, true),
  adminSendInvite:          (id, body) => request("/admin/customers/" + id + "/invite", { method: "POST", body: JSON.stringify(body) }, true),
  adminGetInvites:          ()         => request("/admin/invites", {}, true),
  adminCancelInvite:        (id)       => request("/admin/invites/" + id, { method: "DELETE" }, true),
  adminGetCustomerInvites:  (id)       => request("/admin/customers/" + id + "/invites", {}, true),
  adminResendInvite:        (id)       => request("/admin/invites/" + id + "/resend", { method: "POST" }, true),

  // Super admin
  superAdminGetAdmins:     ()          => request("/super-admin/admins", {}, true),
  superAdminCreateAdmin:   (body)      => request("/super-admin/admins", { method: "POST", body: JSON.stringify(body) }, true),
  superAdminUpdateAdmin:   (id, body)  => request("/super-admin/admins/" + id, { method: "PATCH", body: JSON.stringify(body) }, true),
  superAdminDeleteAdmin:   (id)        => request("/super-admin/admins/" + id, { method: "DELETE" }, true),
  superAdminSendReset:     (id)        => request("/super-admin/admins/" + id + "/send-reset", { method: "POST" }, true),
};
